import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Box,
  Button,
} from "@mui/material";
import WestIcon from "@mui/icons-material/West";
import { NavLink } from "react-router-dom";

const UserVideoPage = () => {
  const [videos, setVideos] = useState([]);
  const [viewCounts, setViewCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const userId = localStorage.getItem("userMail"); // Store user ID
  const selectedSubject = "UG";

  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    try {
      const res = await axios.get(
        `https://userspeedacademy.vebbox.in/speedbackend/controllers/api/User/get/U_VideoPg.php?category=${selectedSubject}`
      );
      setVideos(res.data);

      const viewsRes = await axios.get(
        `https://userspeedacademy.vebbox.in/speedbackend/controllers/api/User/get/U_GetUserVideoCounts.php?email=${userId}`
      );
      setViewCounts(viewsRes.data); // { video_id: { views: 2, granted: 1 } }
      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  };

  const handlePlay = async (videoId) => {
    const currentView = viewCounts[videoId] || { views: 0, granted: 1 };

    if (currentView.views >= 3 && currentView.granted === 0) {
      alert("View limit reached. Please request access.");
      return;
    }

    // Count this view
    try {
      await axios.post(
        "https://userspeedacademy.vebbox.in/speedbackend/controllers/api/User/post/U_TrackVideoView.php",
        { email: userId, video_id: videoId }
      );
      fetchVideos(); // update viewCounts
    } catch (err) {
      console.error("Failed to track view", err);
    }
  };

  const handleRequestAccess = async (videoId) => {
    try {
      const res = await axios.post(
        "https://userspeedacademy.vebbox.in/speedbackend/controllers/api/User/post/U_RequestAccess.php",
        { email: userId, video_id: videoId }
      );

      const status = res.data.status;

      if (status === "requested") {
        alert("Request sent to admin for approval.");
      } else if (status === "already_requested") {
        alert(
          "Access request is already pending. Please wait for admin approval."
        );
      } else {
        alert("Unexpected response. Please try again later.");
      }
    } catch (err) {
      console.error("Request error", err);
      alert("Something went wrong. Please try again later.");
    }
  };

  return (
    <Box
      sx={{ padding: "3rem", backgroundColor: "#f9f9f9", minHeight: "100vh" }}
    >
      <Typography
              style={{
                fontSize: "20px",
                fontWeight: 600,
                textAlign: "center",
                paddingBottom: "20px",
              }}
            >
              <NavLink to="/card" style={{ color: "black" }}>
                <WestIcon />
              </NavLink>
              &nbsp;UG-VIDEO
            </Typography>
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold", marginBottom: "2rem" }}
      >
        {selectedSubject} Video Lectures
      </Typography>

      {loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center", marginTop: "3rem" }}
        >
          <CircularProgress />
        </Box>
      ) : videos.length === 0 ? (
        <Typography align="center" color="textSecondary" variant="h6">
          No videos available for {selectedSubject}.
        </Typography>
      ) : (
        <Grid container spacing={6} justifyContent="center">
          {videos.map((video) => {
            const videoView = viewCounts[video.id] || { views: 0, granted: 1 };
            const effectiveViews =
              videoView.granted === 0 ? videoView.views : 0;
            const isBlocked = effectiveViews >= 2 && videoView.granted === 0;

            return (
              <Grid item xs={12} sm={10} md={8} lg={6} key={video.id}>
                <Card
                  sx={{
                    boxShadow: 6,
                    borderRadius: "16px",
                    overflow: "hidden",
                  }}
                >
                  <video
                    width="100%"
                    height="400"
                    controlsList="nodownload"
                    controls={!isBlocked}
                    onPlay={(e) => {
                      const currentTime = e.target.currentTime;
                      if (currentTime < 0.1) {
                        handlePlay(video.id);
                      }
                    }}
                    style={{ backgroundColor: "#000" }}
                    onContextMenu={(e) => e.preventDefault()}
                    src={isBlocked ? "" : video.video_path}
                  >
                    Your browser does not support the video tag.
                  </video>

                  <CardContent sx={{ padding: "1.5rem" }}>
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>
                      {video.title}
                    </Typography>
                    <Typography variant="body1" color="textSecondary">
                      {video.description}
                    </Typography>
                    {isBlocked && (
                      <Button
                        onClick={() => handleRequestAccess(video.id)}
                        variant="contained"
                        color="primary"
                        sx={{ marginTop: 2 }}
                      >
                        Request Access
                      </Button>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}
    </Box>
  );
};

export default UserVideoPage;

